export enum LangEnum {
  EN = "en",
  BG = "bg",
  RO = "ro",
  EL = "el", // Stands for Greek
}
